export default __webpack_public_path__ + "static/media/parallax_contact.f42c5c9a.jpg";